// extracted by mini-css-extract-plugin
module.exports = {"mobile":"500px","header":"ReviewsSection_header__iQa2j","title":"ReviewsSection_title__9BiCb","widget":"ReviewsSection_widget__78vQo"};